module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-dress-image-2-71ae84ccc7e08a0706d2bb703ad7c355.png";